import {TOAST_MESSAGE_ADDED, TOAST_MESSAGE_REMOVED, TOAST_MESSAGES_REMOVED} from './actions';

const toasts = (state = [], action) => {
    switch (true) {
        case action.type === TOAST_MESSAGE_ADDED && Array.isArray(state):
            state = JSON.parse(JSON.stringify(state));
            state.push({
                severity: action.severity,
                body: action.body,
                id: action.id,
                persist: action.persist,
                display_length: action.display_length
            });
            break;
        case action.type === TOAST_MESSAGE_REMOVED && Array.isArray(state):
            state = JSON.parse(JSON.stringify(state));
            const index = state.findIndex(toast => toast.id === action.id);
            if (index >= 0) {
                state.splice(index, 1);
            }
            break;
        case action.type === TOAST_MESSAGES_REMOVED && Array.isArray(state):
            state = []
            break;
    }

    return state;
};

export default toasts;
